export interface ISelfieKycContainerProps {
  [key: string]: any
}

export interface ISelfieKycStartProps {
  onNext: () => void
  onRequestCameraAccess: () => void
  hasCameraPermission: boolean
  isRequestingAccess?: boolean
}

export enum SelfieKycStep {
  Start = 'start',
  Permission = 'permission',
  Recording = 'recording',
  Confirm = 'confirm',
  Success = 'success',
}

export interface ISelfieKycState {
  step: SelfieKycStep
  videoBlob?: Blob
}
